import React from "react";
import { InlineMath, BlockMath } from "react-katex";
import FractionInput from "../../../../components/inputs/FractionInput";

// ==== GENERATOR ====

export function generateTask() {
  const K0 = (Math.floor(Math.random() * 10) + 1) * 1000; // 1000, 2000…
  const p = Math.floor(Math.random() * 8) + 5;            // 5–12%
  const n = Math.floor(Math.random() * 5) + 2;            // 2–6 lat

  const mOptions = [3, 4, 6, 12];
  const m = mOptions[Math.floor(Math.random() * mOptions.length)];

  const factor = 1 + p / (100 * m);
  const Kn = +(K0 * Math.pow(factor, n * m)).toFixed(2);

  return {
    type: "FindFinalAmountMultipleCapitalizationTask",
    data: { K0, p, n, m, Kn }
  };
}

// ==== RENDER ====

export function renderTask({ data }) {
  const { K0, p, n, m } = data;

  return (
    <>
      <p>
        Kapitał początkowy <InlineMath math={`K_0 = ${K0}`} /> zł
        został złożony na lokacie z rocznym oprocentowaniem{" "}
        <InlineMath math={`${p}\\%`} /> na okres{" "}
        <InlineMath math={`${n}`} /> lat, przy kapitalizacji co{" "}
        <InlineMath math={`${12 / m}`} /> miesięcy.
      </p>
      <p>
        Oblicz kapitał końcowy <InlineMath math={`K_n`} />.
      </p>
    </>
  );
}

export function renderInput(_, userAnswer, onChange, disabled) {
  return (
    <FractionInput
      value={userAnswer}
      onChange={onChange}
      disabled={disabled}
      label="K"
      suffixLatex="\text{zł}"
    />
  );
}

export function checkAnswer({ data }, userAnswer) {
  if (!userAnswer || typeof userAnswer !== "object") return false;
  const given = parseFloat(userAnswer.raw);
  if (isNaN(given)) return false;

  return Math.abs(given - data.Kn) < 0.01;
}

export function renderAnswer({ data }) {
  const { Kn, n } = data;

  const isApprox = !(Number.isInteger(Kn) || Kn === parseFloat(Kn.toFixed(0)));
  const symbol = isApprox ? '\\approx' : '=';

  return (
    <InlineMath math={`K_{${n}} ${symbol} ${Kn} \\, \\text{zł}`} />
  );
}

export function renderExplanation({ data }) {
  const { K0, p, n, m, Kn } = data;

  const factor = 1 + p / (100 * m);

  const powerResult = Math.pow(factor, n * m);
  const powerRounded = parseFloat(powerResult.toFixed(3));

  const isKnApprox =
    Math.abs(Kn - Math.round(Kn)) > 1e-2 &&
    Math.abs(Kn - parseFloat(Kn.toFixed(0))) > 1e-2;

  const knSymbol = isKnApprox ? '\\approx' : '=';

  const isPowerApprox =
    Math.abs(powerResult - powerRounded) > 1e-10;

  const powerSymbol = isPowerApprox ? '\\approx' : '=';

  const months = 12 / m;

  return (
    <div className="space-y-2">
      <p>
        <strong>Krok 1:</strong> Obliczamy liczbę okresów kapitalizacji w roku:
      </p>
      <p>
        Ponieważ kapitalizacja następuje co <InlineMath math={`${months}`} /> miesięcy, to w roku są{" "}
        <InlineMath math={`${m}`} /> okresy kapitalizacji (bo{" "}
        <InlineMath math={`12 / ${months} = ${m}`} />).
      </p>

      <p>
        <strong>Krok 2:</strong> Wzór na kapitał końcowy:
      </p>
      <BlockMath math={`K_{${n}} = K_0 \\cdot \\left(1 + \\frac{p}{100m}\\right)^{n \\cdot m}`} />

      <p>
        <strong>Krok 3:</strong> Podstawiamy dane:
      </p>
      <BlockMath math={`K_{${n}} = ${K0} \\cdot \\left(1 + \\frac{${p}}{100 \\cdot ${m}}\\right)^{${n} \\cdot ${m}}`} />
      <BlockMath math={`K_{${n}} = ${K0} \\cdot (${factor.toFixed(5)})^{${n * m}}`} />
      <BlockMath math={`K_{${n}} ${powerSymbol} ${K0} \\cdot ${powerRounded}`} />
      <BlockMath math={`K_{${n}} ${knSymbol} ${Kn} \\, \\text{zł}`} />
    </div>
  );
}


export function renderUserAnswer(userAnswer, task) {
  const n = task?.data?.n || 'n';

  if (!userAnswer || typeof userAnswer !== "object" || !userAnswer.raw) {
    return <i>(brak odpowiedzi)</i>;
  }

  return <InlineMath math={`K_{${n}} = ${userAnswer.raw}`} />;
}
